import { Action } from "redux";

export type AuthLogoutRequest = "AUTH_LOGOUT_REQUEST";
export const AUTH_LOGOUT_REQUEST: AuthLogoutRequest = "AUTH_LOGOUT_REQUEST";

export interface AuthLogoutRequestAction extends Action {
    type: AuthLogoutRequest;
}

export function logout(): AuthLogoutRequestAction {
    return {
        type: AUTH_LOGOUT_REQUEST
    };
}